{
	"portfolioBlocks": {
		"blocks": "Blocks",
		"portfolioValue": "Portfolio, USD",
		"profitability": "Profitability",
		"portfolioValuation": "Portfolio Valuation",
		"riskLevel": "Risk level"
	}
}
